
import { useState } from 'react';
import { X } from 'lucide-react';

const DisclaimerBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 text-gray-700 py-2 px-4 text-center text-sm relative">
      <p className="max-w-7xl mx-auto">
        Deepseek.ai is an independent website and is not affiliated with, sponsored by, or endorsed by Hangzhou DeepSeek Artificial Intelligence Co., Ltd.
      </p>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
        aria-label="Close disclaimer"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default DisclaimerBanner;
